import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import BankTransferDetails from './BankTransferDetails';
import {
  formatDate,
  formatPrice,
  shouldShowBankTransferNextSteps,
  unpaidBankTransferPayments,
} from './reservationUtils';

const PendingPaymentNextSteps = ({ order, payments, bankTransferConfig }) => {
  if (!shouldShowBankTransferNextSteps(order, payments, bankTransferConfig)) {
    return null;
  }

  const unpaidTransfer = unpaidBankTransferPayments(payments);
  const nextPayment = unpaidTransfer[0];
  const totalUnpaid = unpaidTransfer.reduce(
    (sum, p) => sum + (Number(p.amountDue) || 0),
    0
  );

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
        Następne kroki
      </Typography>
      <Paper variant="outlined" sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Box
          component="ol"
          sx={{
            m: 0,
            pl: 2.5,
            lineHeight: 1.6,
            '& li:not(:last-child)': { mb: 1 },
          }}
        >
          <li>
            Opłać kwotę <strong>{formatPrice(nextPayment.amountDue)}</strong> do dnia{' '}
            <strong>{formatDate(nextPayment.dueDate)}</strong> przelewem bankowym.
          </li>
          {unpaidTransfer.length > 1 && (
            <li>
              Łączna kwota pozostała do zapłaty: <strong>{formatPrice(totalUnpaid)}</strong>.
            </li>
          )}
          <li>
            W tytule przelewu podaj numer rezerwacji{' '}
            <strong>{order?.confirmationNumber ?? '—'}</strong>.
          </li>
          <li>Po zaksięgowaniu środków otrzymasz e-mail z potwierdzeniem rezerwacji.</li>
        </Box>
        <Box sx={{ mt: 3 }}>
          <BankTransferDetails
            config={bankTransferConfig}
            confirmationNumber={order?.confirmationNumber}
            embedded
          />
        </Box>
      </Paper>
    </>
  );
};

export default PendingPaymentNextSteps;
